module.exports = __webpack_public_path__ + "static/media/Alpha-iQ-RA-6800-iQ.34defd21.png";